import { observable, makeObservable } from "mobx";
import { getVentEvents } from "../../serviceCalls";
import * as _ from "lodash";

export default class VentilatorEventsStore {
  loading;
  events;

  constructor() {
    makeObservable(this, {
      loading: observable,
      events: observable,
    });

    this.fetchVentEvents();
  }

  fetchVentEvents() {
    this.loading = true;
    return getVentEvents()
      .then(
        (res) =>
          (this.events = {
            alarms: _.sortBy(res.alarms, "timestamp").reverse(),
          }),
      )
      .finally(() => (this.loading = false));
  }
}
